module.exports = __webpack_public_path__ + "static/media/icn-close.0d10bc66.svg";